<div class="viewport-1" [style.background-image]="'url(' + interventionTaskService.taskBackgroundImage() + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="taskTotalPoints"></task-bar>

  <div class="task-screen-element fill-in-blank-container"
    [style.background-image]="' ' + interventionTaskService.taskContainerColor() + ' '"
    [class]="(animationComplete || !animateContainer) ? 'taskShow' : 'taskHide'">
    <div class="testType font-18">{{interventionTaskService.testType()}}</div>
    <div class="timer-bar-container">
      <trial-timer-bar></trial-timer-bar>
      <button [class]="(hideTimer) ? 'replayVideo-no-timerbar' : 'replayVideo'" (click)="replayVideo()"
      [disabled]="disableAVButtons"></button>
    </div>
    <div [class]="(isUnit) ? 'word-to-complete-unit-mtp' : 'word-to-complete'">
      <div class="audio-controls-container">
        <button class="speaker" (click)="playTargetAudioViaSpeakerClick()" [disabled]="disableAVButtons"></button>
        <button class="snail-button" (click)="playTargetAudioSlowed()" [disabled]="disableAVButtons"></button>
      </div>
      <div class="target-row">
        @if (isUnit) {
          <div class="position-target"></div>
        }
        @for (letter of targetWord; track $index) {
          <div class="stw-target-div" [class.intervention-target-block]="isUnit"
            >
            @if (!oneIncorrectAnswer) {
              <button class = "target-letter-audio-hidden stw"></button>
            }
            @if (oneIncorrectAnswer) {
              <button class = "target-letter-audio stw"
              (click)="playTargetLetterAudio($index)" [disabled]="disableAVButtons"></button>
            }
            <button class="stw-target-block font-30" [class.hover]="$index==blankTile"
              [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '">
              {{letter.text}}
            </button>
            <button [class]="{'remove-letter-disabled': letter.disabled, 'remove-letter': !letter.disabled, 'remove-letter-disabled-hover': ($index==blankTile)}"
              [class]="letter.disabled ? 'remove-letter-disabled' : 'remove-letter'"
            (click)="removeLetter($index)" [disabled]="letter.disabled"></button>
          </div>
        }
      </div>
      @if (!hideSubmitButton) {
        <button (click)="submitResponse()"
          [class]="(disableSubmitButton) ? 'star-submit-disabled' : 'star-submit'"
        [disabled]="disableSubmitButton"></button>
      }
    </div>
    <div class="response-row">
      @for (response of responseOptions1; track response.text) {
        <div class="button-div">
          @if (!showResponseAudioButtons) {
            <button class = "letter-audio-hidden"></button>
          }
          @if (showResponseAudioButtons) {
            <button class = "letter-audio"
              (click)="playLetterAudio(response.audio)"
            [disabled]="disableAVButtons || disableResponseButtons"></button>
          }
          <button class="font-30"
            [class]="(disableResponseButtons) ? 'response-block-grayed' : 'response-block'"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            [disabled]="disableResponseButtons" (click)="addLetter($index)">
            {{response.text}}
          </button>
          @if (response.hasSilentE) {
            <button class="font-24" [class]="(disableResponseButtons) ? 'silent-e-grayed' : 'silent-e'"
              [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
              [disabled]="disableResponseButtons" (click)="addLetter($index)">
              e
            </button>
          }
          @if (!response.hasSilentE) {
            <button class="silent-e-hidden"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"></button>
          }
        </div>
      }
    </div>
    <div class="response-row">
      <!-- use $index + 4 so we can keep the index returned unique because $index resets when we start a new ng-repeat -->
      @for (response of responseOptions2; track response.text) {
        <div class="button-div">
          @if (!showResponseAudioButtons) {
            <button class = "letter-audio-hidden"></button>
          }
          @if (showResponseAudioButtons) {
            <button class = "letter-audio"
              (click)="playLetterAudio(response.audio)"
            [disabled]="disableAVButtons || disableResponseButtons"></button>
          }
          <button class="font-30"
            [class]="(disableResponseButtons) ? 'response-block-grayed' : 'response-block'"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            [disabled]="disableResponseButtons" (click)="addLetter($index+4)">
            {{response.text}}
          </button>
          @if (response.hasSilentE) {
            <button class="font-24"
              [class]="(disableResponseButtons) ? 'silent-e-grayed' : 'silent-e'"
              [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
              [disabled]="disableResponseButtons" (click)="addLetter($index+4)">
              e
            </button>
          }
          @if (!response.hasSilentE) {
            <button class="silent-e-hidden"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"></button>
          }
        </div>
      }
    </div>
  </div>
  @if (isDevMode) {
    <div>{{wordListAttempt}} - {{task.wordlistType}}</div>
  }

  <trial-counter [showCorrectIncorrect]="true" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTaskData()"></save-data-dialog>
  <focus-dialog></focus-dialog>
</div>
